var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"collection-page ls-container",class:{ 'pt-4': _vm.$vuetify.breakpoint.lgAndUp }},[_c('Banner',{attrs:{"banner":_vm.collection && _vm.collection.banner}}),_c('AppFeed',{staticClass:"mt-5"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }